
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[partner]",
      function () {
        return require("private-next-pages/[partner]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[partner]"])
      });
    }
  